"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BadFaceIcon = function (_a) {
    var color = _a.color;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("svg", { width: "33", height: "33", viewBox: "0 0 33 33", fill: color, xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M16.5517 3.58545C9.19169 3.58545 3.23169 9.55878 3.23169 16.9188C3.23169 24.2788 9.19169 30.2521 16.5517 30.2521C23.925 30.2521 29.8984 24.2788 29.8984 16.9188C29.8984 9.55878 23.925 3.58545 16.5517 3.58545ZM16.565 27.5854C10.6717 27.5854 5.89836 22.8121 5.89836 16.9188C5.89836 11.0254 10.6717 6.25212 16.565 6.25212C22.4584 6.25212 27.2317 11.0254 27.2317 16.9188C27.2317 22.8121 22.4584 27.5854 16.565 27.5854Z", fill: "current" }),
            react_1.default.createElement("line", { x1: "11.3314", y1: "23.6178", x2: "21.4139", y2: "19.985", stroke: color, strokeWidth: "2" }),
            react_1.default.createElement("path", { d: "M10.003 16.208L14.4807 13.8919L10.003 11.3829", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M22.9818 11.6009L18.6198 14.1282L23.2122 16.4205", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
BadFaceIcon.defaultProps = {
    color: 'black',
};
exports.default = BadFaceIcon;
